import React from 'react';
import { IconTheme } from '../../IconsCommonTypes';

function PublicChannel(theme: IconTheme | undefined = undefined) {
  return !theme?.applyZoom ? (
    <svg
      width={theme && theme.width ? theme.width : '44'}
      height={theme && theme.height ? theme.height : '44'}
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      id="PublicChannel"
    >
      <path
        d="M32.9998 20.1667C32.9998 21.395 32.9998 22.605 32.9998 23.8334C35.1998 23.8334 38.0598 23.8334 40.3332 23.8334C40.3332 22.605 40.3332 21.395 40.3332 20.1667C38.0598 20.1667 35.1998 20.1667 32.9998 20.1667Z"
        fill={theme && theme.color ? theme.color : 'var(--color-icon)'}
      />
      <path
        d="M29.3332 32.285C31.0932 33.5867 33.3848 35.31 35.1998 36.6667C35.9332 35.695 36.6665 34.705 37.3998 33.7334C35.5848 32.3767 33.2932 30.6534 31.5332 29.3334C30.7998 30.3234 30.0665 31.3134 29.3332 32.285Z"
        fill={theme && theme.color ? theme.color : 'var(--color-icon)'}
      />
      <path
        d="M37.3998 10.2667C36.6665 9.29504 35.9332 8.30504 35.1998 7.33337C33.3848 8.69004 31.0932 10.4134 29.3332 11.7334C30.0665 12.705 30.7998 13.695 31.5332 14.6667C33.2932 13.3467 35.5848 11.6417 37.3998 10.2667Z"
        fill={theme && theme.color ? theme.color : 'var(--color-icon)'}
      />
      <path
        d="M7.33317 16.5C5.3165 16.5 3.6665 18.15 3.6665 20.1667V23.8334C3.6665 25.85 5.3165 27.5 7.33317 27.5H9.1665V34.8334H12.8332V27.5H14.6665L23.8332 33V11L14.6665 16.5H7.33317ZM16.5548 19.635L20.1665 17.4717V26.5284L16.5548 24.365L15.6748 23.8334H7.33317V20.1667H15.6748L16.5548 19.635Z"
        fill={theme && theme.color ? theme.color : 'var(--color-icon)'}
      />
      <path
        d="M28.4165 22C28.4165 19.5617 27.3532 17.3617 25.6665 15.8584V28.1234C27.3532 26.6384 28.4165 24.4384 28.4165 22Z"
        fill={theme && theme.color ? theme.color : 'var(--color-icon)'}
      />
    </svg>
  ) : (
    <svg
      width={theme && theme.width ? theme.width : '16'}
      height={theme && theme.height ? theme.height : '16'}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9999 7.33342C11.9999 7.78008 11.9999 8.22008 11.9999 8.66675C12.7999 8.66675 13.8399 8.66675 14.6666 8.66675C14.6666 8.22008 14.6666 7.78008 14.6666 7.33342C13.8399 7.33342 12.7999 7.33342 11.9999 7.33342Z"
        fill={theme && theme.color ? theme.color : 'var(--color-icon)'}
      />
      <path
        d="M10.6666 11.7401C11.3066 12.2134 12.1399 12.8401 12.7999 13.3334C13.0666 12.9801 13.3333 12.6201 13.5999 12.2667C12.9399 11.7734 12.1066 11.1467 11.4666 10.6667C11.1999 11.0267 10.9333 11.3867 10.6666 11.7401Z"
        fill={theme && theme.color ? theme.color : 'var(--color-icon)'}
      />
      <path
        d="M13.5999 3.73341C13.3333 3.38008 13.0666 3.02008 12.7999 2.66675C12.1399 3.16008 11.3066 3.78675 10.6666 4.26675C10.9333 4.62008 11.1999 4.98008 11.4666 5.33341C12.1066 4.85341 12.9399 4.23341 13.5999 3.73341Z"
        fill={theme && theme.color ? theme.color : 'var(--color-icon)'}
      />
      <path
        d="M2.66662 6.00008C1.93328 6.00008 1.33328 6.60008 1.33328 7.33342V8.66675C1.33328 9.40008 1.93328 10.0001 2.66662 10.0001H3.33328V12.6667H4.66662V10.0001H5.33328L8.66662 12.0001V4.00008L5.33328 6.00008H2.66662ZM6.01995 7.14008L7.33328 6.35341V9.64675L6.01995 8.86008L5.69995 8.66675H2.66662V7.33342H5.69995L6.01995 7.14008Z"
        fill={theme && theme.color ? theme.color : 'var(--color-icon)'}
      />
      <path
        d="M10.3333 8.00008C10.3333 7.11341 9.94662 6.31341 9.33328 5.76675V10.2267C9.94662 9.68675 10.3333 8.88675 10.3333 8.00008Z"
        fill={theme && theme.color ? theme.color : 'var(--color-icon)'}
      />
    </svg>
  );
}

export default PublicChannel;
